// Currency helpers for multi-currency event pricing.
// Existing events default to GBP; non-GBP events (Nimi Abroad) skip
// credit & referral discounts (see EventBooking + create-checkout).

export type EventCurrency = "gbp" | "eur" | "cad" | "usd";

export const DEFAULT_CURRENCY: EventCurrency = "gbp";

export const isGbp = (currency?: string | null): boolean =>
  (currency || DEFAULT_CURRENCY).toLowerCase() === "gbp";

export const formatPrice = (
  amount: number,
  currency: string | null | undefined = DEFAULT_CURRENCY,
  opts: { compact?: boolean } = {},
): string => {
  const code = (currency || DEFAULT_CURRENCY).toUpperCase();
  try {
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: code,
      minimumFractionDigits: opts.compact && Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2,
    });
    return formatter.format(amount);
  } catch {
    return `${code} ${amount.toFixed(2)}`;
  }
};

export const getCurrencySymbol = (currency?: string | null): string => {
  const code = (currency || DEFAULT_CURRENCY).toUpperCase();
  try {
    const parts = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: code,
    }).formatToParts(0);
    return parts.find((p) => p.type === "currency")?.value ?? code;
  } catch {
    return code;
  }
};
